import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import { convertToAdminAdded } from '../../api/products';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import useAuthToken from '../../hooks/getUserData';

export default function ConvertToAdminAdded({
  product,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {
  const [error, setError] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const token = useAuthToken();

  const handleConvert = useCallback(async () => {
    const response = await convertToAdminAdded(product.id, token);
    
    if (response.ok) {
      setSnackbarOpen(true);
      setMessage('Product converted successfully');
      fetchData();
      setConfirmationOpen(false);
      setError(null);
    } else {
      
      const errorData = await response.json();
      const errorMessage = errorData?.error?.message || 'Failed to convert product. Please try again.';
      setError(errorMessage);
    }
  }, [product, fetchData]);

  const handleConvertButtonClick = () => {
    setError(null);
    setConfirmationOpen(true);
  };

  const handleConvertConfirm = () => {
    handleConvert();
  };

  const handleConvertCancel = () => {
    setConfirmationOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton
        title="Convert to admin added"
        size="small"
        sx={{ p: 2 }}
        onClick={handleConvertButtonClick}>
        <MoveUpIcon />
      </IconButton>

       <Dialog
        open={confirmationOpen}
        onClose={handleConvertCancel}
        fullWidth
        maxWidth="sm">
        <DialogTitle>{error ? 'Error' : 'Confirmation'}</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {!error && (
            <Typography>
              Are you sure you want to convert <strong>{product?.title}</strong> to
              admin added products?
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          {error ? (
            <Button onClick={handleConvertCancel} color="primary">
              OK
            </Button>
          ) : (
            <>
              <Button onClick={handleConvertCancel} color="primary">
                Cancel
              </Button>
              <Button onClick={handleConvertConfirm} color="secondary">
                Convert
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}